import PropTypes from 'prop-types'
import React from 'react'

const ProductStructuredData = ({ product }) => {
  let jsonData = ''
  if (product) {
    const jsonLd = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: product.name,
      brand: {
        '@type': 'Brand',
        name: product.manufacturer,
      },
      description: product.description,
      offers: {
        '@type': 'Offer',
        price: product.price,
      },
    }
    jsonData = JSON.stringify(jsonLd, null, 2)
  }

  return product && <script type="application/ld+json">{jsonData}</script>
}

ProductStructuredData.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string,
    manufacturer: PropTypes.string,
    description: PropTypes.string,
    price: PropTypes.number,
  }).isRequired,
}

export { ProductStructuredData }
